<template>
  <div class="flex" v-if="this.$route.path !== '/login'">
    <SideMenu/>

    <div class="p-4 md:p-10 flex-1">
      <router-view/>
    </div>
  </div>

  <router-view v-else/>

  <div class="flex flex-col absolute top-4 left-4 gap-y-5">

    <transition-group name="slide">
      <VNotification
          v-for="(notification, index) in notifications"
          :key="notification"
          :notification="notification"
          @click="notifications.splice(index, 1)"/>
    </transition-group>

  </div>
</template>

<script>

import SideMenu from "@/components/Homepage/SideMenu";
import {getMessaging, onMessage} from "firebase/messaging";
import firebaseApp from "./utils/firebase";
import VNotification from "@/components/General/VNotification";

export default {
  components: {VNotification, SideMenu},
  data() {
    return {
      notifications: []
    }
  },
  async created() {
    this.$store.dispatch('getLanguages')

    const messaging = getMessaging(firebaseApp);
    onMessage(messaging, (payload) => {
      this.notifications.push(payload.notification)
      this.$store.dispatch('addFcmMessage', payload)
      let audio = new Audio(require('./assets/notification.wav'));
      audio.play();
    });
  }
}
</script>

<style>

</style>
